<template>
  <v-dialog :width="670" v-model="visible" @keydown.esc="cancel">
    <v-card>
      <v-card-text class="pa-4">
        <youtube v-if="visible" :video-id="videoId" @ready="ready" @playing="playing" :player-vars="{ autoplay: 1 }" player-width="100%"></youtube>
      </v-card-text>
      <!-- <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click.native="close">Close</v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 * 
 * See https://gist.github.com/eolant/ba0f8a5c9135d1a146e1db575276177d
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
export default {
  data: () => ({
    videoId: null,
    visible: false,
    resolve: null,
    reject: null,
    options: {
      color: 'primary',
      width: 290,
      zIndex: 200
    }
  }),
  methods: {
    open(videoNumber) {
      this.videoId = videoNumber
      this.visible = true
      // return new Promise((resolve, reject) => {
      //   this.resolve = resolve
      //   this.reject = reject
      // })
    },
    close() {
      // this.resolve(false)
      this.visible = false
    },
    ready (event) {
      this.player = event.target
    },
    playing (event) {
      // The player is playing a video.
    },    
  }
}
</script>


// WEBPACK FOOTER //
// YouTubeDialog.vue?4d91d0e6